import * as amplify from "../util/amplify.ts";
import * as libLocation from "../lib/location.ts";

function setOrientation(){
  const 
    dataByPage = {
      'events.php':{
        orientation:'landscape',
      },
      'recipebox.php':{
        bodyClass:'print-flow'
      },
      'tasks.php':{
        orientation:'portrait',
        bodyClass:'print-flow'
      },
      'budget.php':{
        bodyClass:'print-flow'
      }
    }[libLocation.getPageName()]||{};
  
  if(dataByPage.orientation){
    var style = document.createElement('style')
    style.innerHTML = `@page {
  size :A4 ${dataByPage.orientation};
}`  
    document.getElementById('container').appendChild(style);
  } 
  
  if(dataByPage.bodyClass){
    document.body.setAttribute('class',dataByPage.bodyClass)
  } else{
    document.body.removeAttribute('class')
  }
}


window.addEventListener("beforeprint", (event) => {
  setOrientation()
  
  const fullcalendarNode = document.getElementById('fullcalendar')
  if(fullcalendarNode){
    var crawler = fullcalendarNode
    while(crawler!==document){
      crawler.setAttribute('height-before-print',crawler.style.height)
      crawler.setAttribute('position-before-print',crawler.style.position)
      crawler.style.height = "fit-content !important";
      crawler.style.position = "unset";
      crawler = crawler.parentNode
    }
    fullcalendarNode.style.width = '1054px';
    document.querySelector('.fw-mainpane').style.position = 'unset'
    if(document.querySelector('.fc-timegrid') !== null){
      fullcalendarNode.style.height = '610px'
    }else{
      fullcalendarNode.style.height = '610px'
    }
    amplify.publish('calendarNeedRender')
  }
  
})
window.addEventListener("afterprint", (event) => {
  const fullcalendarNode = document.getElementById('fullcalendar')
  if(fullcalendarNode){
    var crawler = fullcalendarNode
    while(crawler!==document){
      if(crawler.getAttribute('height-before-print')){
        crawler.style.height = crawler.getAttribute('height-before-print');
        crawler.style.position = crawler.getAttribute('position-before-print');
        //crawler.removeAttribute('height-before-print')
      }
      crawler = crawler.parentNode
    }
    fullcalendarNode.style.width = "auto";
    fullcalendarNode.style.height = "";
    
    amplify.publish('calendarNeedRender')
  }
})
